(function (){
    'use strict';


    var extDeps = [];
    var module = angular.module('app.common.widgets.general',extDeps);





    /**
     * CONTROLLERS
     */



    module.controller('SiteNavController',SiteNavController);
    SiteNavController.$inject=['$location', '$state', 'userService','appGlobals','modalService'];
    function SiteNavController($location, $state, userService, appGlobals,modalService){
        var vm = this;
        vm.userDisplayTitle = null;
        vm.userPermissions = null;
        vm.isRouteActive = isRouteActive;
        vm.canNavigateToLayouts = false;
        vm.confirmBeforeSignout = confirmBeforeSignout;

        vm.showNewButton = showNewButton;

        init();

        function init(){
            userService.getUserAsync()
                .then(function(result){
                    vm.userDisplayTitle = result.displayTitle;
                    vm.userPermissions={
                        leave : result.permissions.leave.ListView
                        , payableTime: result.permissions.payableTime.View
                        , payslips: result.permissions.payslips.ListView
                        , profile: result.permissions.profile.View
                        , roster: result.permissions.roster.View || result.permissions.roster.PeriodView
                        , timesheets: result.permissions.timesheets.View
                    };
                });

            vm.canNavigateToLayouts = appGlobals.stubsAreEnabled;
        }


        function isRouteActive(route) {
            var rt = new RegExp(route,'i').test($location.$$absUrl);
            return rt;
        }


        function confirmBeforeSignout(){
            return  modalService.notifyMessage(modalService.newSignoutConfirmModalOptions())
                .then(function(){
                    $state.go('enterModule',{name:'logout'});
                });
        }

        function showNewButton(menuItem) {
            if (menuItem === 'TIMESHEET') {
                var expiry = new Date(2016, 7, 28);
                return (new Date() < expiry);
            }
}
    }




    module.controller('HeaderController', HeaderController);
    HeaderController.$inject=['pageInfo'];
    function HeaderController(pageInfo){
        var vm = this;

        vm.pageTitle = pageInfo.title;

    }



    /**
     * DIRECTIVES
     */



    module.directive("pdfViewer",pdfViewerDirective);
    pdfViewerDirective.$inject=[];
    function pdfViewerDirective() {
        return {
            restrict: "E",
            templateUrl: "/UI/app/common.widgets/pdfViewer.html",
            scope: {
                srcUrl: "&url"
            },
            link: function(scope, element) {

                _renderNativeViewer(element, scope.srcUrl());

            }
        };


        function _renderNativeViewer(element, url){
            var htmlBuilder = [
                '<div class="scroll-wrapper">'
                ,'<embed style="width:100%; height:100%;" '
                , 'src="' + url + '"'
                , 'alt="pdf" type="application/pdf"'
                , 'pluginspage="http://www.adobe.com/products/acrobat/readstep2.html">'
                , '</embed>'
                , '</div>'
            ];

            element.html(htmlBuilder.join(' '));
        }

    }


    module.directive('slickCarousel', slickCarouselDirective);
    slickCarouselDirective.$inject=['$timeout','$parse'];
    function slickCarouselDirective($timeout,$parse){
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {

                var hasVariableWidth = attrs.carouselHasVariableWidth ? $parse(attrs.carouselHasVariableWidth)(scope) : true;
                var hasDots = attrs.carouselHasDots ? $parse(attrs.carouselHasDots)(scope) : true;

                //console.log(variableWidth)
                element.hide();
                $timeout(function(){
                    element.slick({
                        dots: hasDots,
                        speed: 300,
                        slidesToScroll: 2,
                        swipe: true,
                        swipeToSlide: true,
                        touchMove: true,
                        variableWidth: hasVariableWidth,
                        infinite: false
                    })
                        .show();

                },1);

            }
        };

    }


    module.directive('siteNav',siteNavDirective);
    siteNavDirective.$inject=[];
    function siteNavDirective(){
        return{
            restrict:'E',
            templateUrl:'/UI/app/common.widgets/siteNav.html',
            scope:{
                layoutStyles:'@'
            }
        };
    }

    module.directive('userIcon',userIcon);
    userIcon.$inject=[];
    function userIcon(){
        return{
            restrict:'E',
            templateUrl:'/UI/app/common.widgets/userIcon.html',
            scope:{
                userName:'@'
                , isCurrentUser: '@'
            }
            , link: linkFunc
        };

        function linkFunc(scope){
            scope.userName = (scope.userName || '');
            scope.isCurrentUser = (/true/i).test(scope.isCurrentUser);
            setInitialsFromUsername(scope);
            setColourFromUsername(scope);
        }

        function setInitialsFromUsername( scope){

            var userName = scope.userName;

            // get initials
            var tokens = userName.split(' ');
            for(var i=0;i< tokens.length;i++){
                var word = tokens[i];
                if(word.length === 0) continue;

                if(!scope.first)
                    scope.first = word.substr(0,1);
                else if(!scope.last)
                    scope.last = word.substr(0,1);
            }
        }

        function setColourFromUsername(scope){

            var userName = scope.userName;
            if(!userName || scope.isCurrentUser){
                scope.colour = '#423A38';
                return;
            }

            // calculate color
            var sum = 0;
            for(var i=0; i< userName.length ; i++)
                sum += userName.charCodeAt(i);

            var colourList = getColourList();
            var remainder = sum % colourList.length;
            while(remainder > colourList.length)
                remainder = remainder % colourList.length;
            scope.colour = getColourList()[remainder];
        }

        function getColourList(){
            return ['#4A90E2','#C89900','#156178','#783515','#39A4C5','#CE5100','#3CB6DC','#EA5C00','#277809','#EA9C00','#7ED321','#8E5F00','#5B8F22','#664400','#4A51E2','#4D0066','#343BBB','#8000A9','#151B7B','#A44FBF','#4A51E2','#E24A4A','#0902D0','#A53D3D','#05008E','#53A53D','#45CBAD','#265E17','#359580','#104427'];
        }
    }


    module.directive('focusMe', focusMeDirective );
    focusMeDirective.$inject = ['$timeout'];
    function focusMeDirective($timeout) {
        return {
            link: function(scope, element, attrs) {
                scope.$watch(attrs.focusMe, function(value) {
                    if(value === true) {
                        $timeout(function() {
                            element[0].focus();
                            scope[attrs.focusMe] = false;
                        },500);
                    }
                });
            }
        };
    }



    /**
     * FILTERS
     */


    module.filter('unsafe', unsafeFilter);
    unsafeFilter.$inject=['$sce'];
    function unsafeFilter($sce) { return $sce.trustAsHtml; }




    /**
     * Description:
     *     removes white space from text. useful for html values that cannot have spaces
     * Usage:
     *   {{some_text | nospace}}
     */
    module.filter('nospace',nospaceFilter);
    nospaceFilter.$inject=[];
    function nospaceFilter() {
        return function (value) {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }


    //https://github.com/sumitchawla/angularjs-filters
    module.filter("replace",replaceFilter);
    replaceFilter.$inject=[];
    function replaceFilter(){
        return function(str, pattern, replacement, global){
            global = (typeof global == 'undefined' ? true : global);
            try {
                str = str ? (typeof global == 'string' ? str : str.toString()) : '';
                return str.replace(new RegExp(pattern,global ? "g": ""),function(match, group) {
                    return replacement;
                });
            } catch(e) {
                console.error("error in string.replace", e);
                return (str || '');
            }
        }
    }





})();

